export const whatIsBTSEdges = [
  {
    id: "86.108.103.180-94.113.91.4",
    source: "86.108.103.180",
    target: "186.1.43.90",
    type: "straight",
  },
  {
    id: "43.27.66.183-86.108.103.180",
    source: "43.27.66.183",
    target: "86.108.103.180",
    type: "straight",
  },
  {
    id: "182.49.39.109-192.135.109.25",
    source: "182.49.39.109",
    target: "192.135.109.25",
    type: "straight",
  },
];
